import { useState } from 'react';
import { CalendarCheck, CalendarDays, CalendarRange } from 'lucide-react';
import { PageHeader } from '@/components/PageHeader.jsx';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/Dialog.jsx';
import HolidaysPage from './HolidaysPage.jsx';
import LeaveTypesPage from './LeaveTypesPage.jsx';
import ShiftCalendarPage from './ShiftCalendarPage.jsx';

const CARDS = [
  { key: 'holidays',       label: 'Holidays',       icon: CalendarCheck, description: 'Public & company holidays',   component: HolidaysPage,      size: 'xl' },
  { key: 'leave-types',   label: 'Leave Types',    icon: CalendarDays,  description: 'Annual, sick, casual & more', component: LeaveTypesPage,    size: 'lg' },
  { key: 'shift-calendar', label: 'Shift Calendar', icon: CalendarRange, description: 'Monthly shift roster & locks', component: ShiftCalendarPage, size: 'xl' },
];

export default function HRPoliciesHub() {
  const [active, setActive] = useState(null);

  const activeCard = CARDS.find((c) => c.key === active);

  return (
    <div className="space-y-6">
      <PageHeader title="HR Policies" description="Leave types and company holiday calendar" />

      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2">
        {CARDS.map(({ key, label, icon: Icon, description }) => (
          <button
            key={key}
            type="button"
            onClick={() => setActive(key)}
            title={description}
            className="group flex flex-col items-center gap-2 rounded-xl p-3 text-center transition-all hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-600 dark:bg-brand-500 text-white shadow-sm group-hover:bg-brand-700 dark:group-hover:bg-brand-400 transition-colors">
              <Icon className="h-5 w-5" />
            </span>
            <span className="text-xs font-medium text-slate-700 dark:text-slate-300 leading-tight line-clamp-2 w-full">{label}</span>
          </button>
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={(v) => !v && setActive(null)}>
        <DialogContent size={activeCard?.size ?? 'lg'}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {activeCard && <activeCard.icon className="h-5 w-5 text-brand-600" />}
              {activeCard?.label}
            </DialogTitle>
          </DialogHeader>
          {activeCard && <activeCard.component />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
